// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProfileTwoToneSvg from "@ant-design/icons-svg/es/asn/ProfileTwoTone";
import AntdIcon from '../components/AntdIcon';

var ProfileTwoTone = function ProfileTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProfileTwoToneSvg
  }));
};

ProfileTwoTone.displayName = 'ProfileTwoTone';
export default React.forwardRef(ProfileTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ProfileTwoTone.js
// module id = 1623
// module chunks = 0